import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AlarmRuleActionEmailConfig, AlarmRuleActionType } from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { AlarmRuleActionFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleAction } from '../base-rule-action';
import { EmailAction } from './email-action';

export class EmailRuleAction extends BaseRuleAction {
  public getDescription(): string {
    return 'common.alarm-rule.action.email.description';
  }

  public getIcon(): string {
    return 'mail';
  }

  public getName(): string {
    return 'common.alarm-rule.action.email.title';
  }

  public getType(): AlarmRuleActionType {
    return AlarmRuleActionType.EMAIL;
  }

  public getEditorComponent(): any {
    return EmailAction;
  }

  public override configToFrom(data: AlarmRuleActionEmailConfig): Record<string, unknown> {
    return {
      emailTo: data.to,
    };
  }

  public override getFromControls(): Record<string, AbstractControl> {
    return {
      emailTo: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [
          Validators.required,
          this.emailArrayValidator(),
        ],
      }),
    };
  }

  public formToConfig(form: AlarmRuleActionFormDto): Record<string, unknown> {
    return {
      to: form.emailTo ?? [],
    };
  }

  public EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  private emailArrayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emails: string[] = control.value;

      if (!Array.isArray(emails) || emails.length === 0) {
        return { required: true };
      }

      const hasInvalid = emails.some(email => !this.EMAIL_REGEX.test(email.trim()));
      return hasInvalid ? { invalidEmail: true } : null;
    };
  }
}